import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    orderBy,
    limit,
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addQuoteTemplates,
    addSingleQuoteTemplate,
    updateQuoteTemplates,
    updateSingleQuoteTemplate,
    deleteSingleQuoteTemplate,
    getSingleQuoteTemplate,
    searchQuoteTemplates,
    getAllQuoteTemplates,
    prepareQuoteTemplatesList
}

const collectionName = 'quote-templates';
const collectionReference = collection(fireStoreDB, collectionName);

const addQuoteTemplates = (quoteTemplates) => {
    return Promise.map(quoteTemplates, async quoteTemplate => {
        console.log('.');
        await addSingleQuoteTemplate(quoteTemplate);
    });
}

const updateQuoteTemplates = (quoteTemplates) => {
    return Promise.map(quoteTemplates, async quoteTemplate => {
        console.log('.');
        await updateSingleQuoteTemplate(quoteTemplate);
    });
}

const addSingleQuoteTemplate = (quoteTemplate) => {
    quoteTemplate.createdAt = new Date();
    quoteTemplate.updatedAt = quoteTemplate.createdAt;
    return addDoc(collectionReference, quoteTemplate);
}

const updateSingleQuoteTemplate = (quoteTemplate) => {
    const documentReference = doc(fireStoreDB, collectionName, quoteTemplate.id);
    quoteTemplate.updatedAt = new Date();
    return setDoc(documentReference, quoteTemplate);
}

const deleteSingleQuoteTemplate = (quoteTemplate) => {
    const documentReference = doc(fireStoreDB, collectionName, quoteTemplate.id);
    return deleteDoc(documentReference);
}

const getSingleQuoteTemplate = (quoteTemplateId) => {
    const documentReference = doc(fireStoreDB, collectionName, quoteTemplateId);
    return getDoc(documentReference);
}

const searchQuoteTemplates = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery,
        limit(20));

    const quoteTemplateResult = await getDocs(searchQuery);
    return prepareQuoteTemplatesList(quoteTemplateResult);
}

const getAllQuoteTemplates = async (quoteId) => {
    let searchQuery = query(collectionReference);

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    /*let searchQuery = query(collectionReference,
        where("quoteId", "==", quoteId));*/

    const quoteTemplateResult = await getDocs(searchQuery);
    return prepareQuoteTemplatesList(quoteTemplateResult);
}

const prepareQuoteTemplatesList = (quoteTemplateResult) => {
    const quoteTemplatesList = [];

    _.forEach(quoteTemplateResult.docs, quoteTemplateDoc => {
        quoteTemplatesList.push({
            ...quoteTemplateDoc.data(),
            id: quoteTemplateDoc.id
        });
    });

    return quoteTemplatesList;
}
